var $ = jQuery;

module.exports = {
	updateProgTableVisibilitySetting: function() {
		if ( ! wpmdb_data.prog_tables_visibility_changed ) {
			return;
		}
		wpmdb_data.prog_tables_visibility_changed = false;

		$.ajax( {
			url: ajaxurl,
			type: 'POST',
			dataType: 'text',
			cache: false,
			data: {
				action: 'wpmdb_save_setting',
				nonce: wpmdb_data.nonces.save_setting,
				setting: 'prog_tables_hidden',
				checked: Boolean( wpmdb_data.prog_tables_hidden )
			},
			error: function( jqXHR, textStatus, errorThrown ) {
				console.log( 'Could not save progress item visibility setting', errorThrown );
			}
		} );
	},
	updatePauseBeforeFinalizeSetting: function() {
		if ( ! wpmdb_data.pause_before_finalize_changed ) {
			return;
		}
		wpmdb_data.pause_before_finalize_changed = false;

		$.ajax( {
			url: ajaxurl,
			type: 'POST',
			dataType: 'text',
			cache: false,
			data: {
				action: 'wpmdb_save_setting',
				nonce: wpmdb_data.nonces.save_setting,
				setting: 'pause_before_finalize',
				checked: Boolean( wpmdb_data.pause_before_finalize )
			},
			error: function( jqXHR, textStatus, errorThrown ) {
				console.log( 'Could not save pause before finalize setting', errorThrown );
			}
		} );
	}
};



// WEBPACK FOOTER //
// ./src/wp-migrate-db-pro/asset/src/js/modules/MigrationProgress-utils.js